<section class="storage-grants">
  <div class="storage-grants-header">
    <div>
      <h3 class="storage-grants-title">Storage access</h3>
      <p class="storage-grants-description">
        Keyless GCS connections use Enlighten's own service account instead of a
        stored key. Ask for the bucket here; an Enlighten administrator approves it.
      </p>
    </div>
    @if (!requesting()) {
      <button
        mat-stroked-button
        color="primary"
        (click)="startRequest()"
        [disabled]="atPendingLimit()"
        aria-label="Request storage access"
      >
        <mat-icon>add</mat-icon>
        <span>Request access</span>
      </button>
    }
  </div>

  @if (atPendingLimit()) {
    <p class="storage-grants-hint">
      This project has the most pending requests allowed. Withdraw one, or wait for a decision.
    </p>
  }

  @if (error()) {
    <div class="storage-grants-error" role="alert">{{ error() }}</div>
  }

  @if (requesting()) {
    <form class="storage-grants-form" (ngSubmit)="submitRequest()">
      <div class="form-row">
        <mat-form-field appearance="outline" class="flex-1">
          <mat-label>GCS bucket</mat-label>
          <input
            matInput
            name="bucket"
            autocomplete="off"
            spellcheck="false"
            placeholder="my-bucket"
            [ngModel]="bucket()"
            (ngModelChange)="bucket.set($event)"
            required
          />
          @if (bucketProblem()) {
            <mat-hint class="storage-grants-invalid">{{ bucketProblem() }}</mat-hint>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" class="flex-1">
          <mat-label>Prefix (optional)</mat-label>
          <input
            matInput
            name="prefix"
            autocomplete="off"
            spellcheck="false"
            placeholder="team/data"
            [ngModel]="prefix()"
            (ngModelChange)="prefix.set($event)"
          />
          <mat-hint>Leave blank for the whole bucket.</mat-hint>
        </mat-form-field>
      </div>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Why the project needs it (optional)</mat-label>
        <textarea
          matInput
          name="note"
          rows="2"
          [ngModel]="note()"
          (ngModelChange)="note.set($event)"
        ></textarea>
      </mat-form-field>
      <p class="storage-grants-hint">
        Once it's approved you'll get a notification naming the Enlighten service
        account to grant on the bucket. The bucket's owner does that in Google Cloud.
      </p>
      <div class="storage-grants-actions">
        <button mat-button type="button" (click)="cancelRequest()">Cancel</button>
        <button mat-flat-button color="primary" type="submit" [disabled]="!canSubmit()">
          @if (submitting()) {
            <mat-spinner diameter="16"></mat-spinner>
          }
          Request access
        </button>
      </div>
    </form>
  }

  @if (loading() && grants().length === 0) {
    <div class="storage-grants-loading"><mat-spinner diameter="24"></mat-spinner></div>
  } @else if (grants().length === 0) {
    <p class="storage-grants-empty">No storage access requested yet.</p>
  } @else {
    <div class="storage-grants-table">
      @for (grant of grants(); track grant.storageGrantId) {
        <div class="storage-grants-row" [class.ended]="!canWithdraw(grant)">
          <div class="storage-grants-location">
            <span class="location">{{ location(grant) }}</span>
            @if (grant.prefix === '') {
              <span class="whole-bucket">whole bucket</span>
            }
          </div>
          <span class="status status-{{ grant.status.toLowerCase() }}">{{ grant.status }}</span>
          <div class="storage-grants-notes">
            @if (grant.decisionNote) {
              <span>{{ grant.decisionNote }}</span>
            } @else if (grant.requestNote) {
              <span class="muted">{{ grant.requestNote }}</span>
            }
            <span class="muted date">Requested {{ grant.requestedAt | serverDate: 'mediumDate' }}</span>
          </div>
          <div class="storage-grants-row-actions">
            @if (canWithdraw(grant)) {
              <button mat-button color="warn" (click)="withdraw(grant)" [disabled]="withdrawing() !== null">
                {{ grant.status === 'Approved' ? 'Give up' : 'Withdraw' }}
              </button>
            }
          </div>
        </div>
      }
    </div>
  }
</section>
